import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Stack from 'react-bootstrap/Stack';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useState } from "react";
import { addProctorAvailability } from '../../control/proctorAvailabilityData';
import { useNavigate } from 'react-router-dom';

function AddProctor() {

    const [proctorFirstName, setProctorFirstName] = useState("");
    const [proctorLastName, setProctorLastName] = useState("");
    const [proctorLocation, setProctorLocation] = useState("");
    
    const [availability, setAvailability] = useState({
        Monday: {selected: false, startTime:"", endTime:"", timeSlots:[] },
        Tuesday: {selected: false, startTime:"", endTime:"", timeSlots:[] },
        Wednesday: {selected: false, startTime:"", endTime:"", timeSlots:[] },
        Thursday: {selected: false, startTime:"", endTime:"", timeSlots:[] },
        Friday: {selected: false, startTime:"", endTime:"", timeSlots:[] },
    });

    const timeOptions = [
      "12:00 AM", "1:00 AM", "2:00 AM", "3:00 AM", "4:00 AM", "5:00 AM", "6:00 AM", "7:00 AM",
      "8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM",
      "4:00 PM", "5:00 PM", "6:00 PM", "7:00 PM", "8:00 PM", "9:00 PM", "10:00 PM", "11:00 PM"
    ];

    const dynamicEndTimes = (day) => {
      const startTime = availability[day].startTime;
      if (!startTime) return timeOptions;
      const startTimeIndex = timeOptions.indexOf(startTime);
      return timeOptions.slice(startTimeIndex + 1);
    };

    const generateTimeSlots = (startTime, endTime) => {
      const startIndex = timeOptions.indexOf(startTime);
      const endIndex = timeOptions.indexOf(endTime);
      const timeSlots = timeOptions.slice(startIndex, endIndex);
      return timeSlots;
    }

    const handleProctorFirstName = (e) => {
      setProctorFirstName(e.target.value);
    };

    const handleProctorLastName = (e) => {
      setProctorLastName(e.target.value);
    };

    const handleLocation = (e) => {
      setProctorLocation(e.target.value);
    }

    const handleDayChange = (day) => {
        setAvailability({
            ...availability, 
            [day]: {...availability[day], selected: !availability[day].selected, startTime:"", endTime:""}, 
        })
    };

    const handleStartTime = (day, e) => {
      setAvailability({
        ...availability, 
        [day] : {...availability[day], startTime: e.target.value, endTime:""}});  
    }

    const handleEndTime = (day, e) => {
      setAvailability({
        ...availability, 
        [day] : {...availability[day], endTime: e.target.value}});
    }

    const isValid = Object.keys(availability).every(day => {
      if (availability[day].selected) {
        return availability[day].startTime && availability[day].endTime;
      }
      return true;
    })

    const updateTimeSlots = () => {
      const finalAvailability = { ... availability };
      Object.keys(finalAvailability).forEach(day => {
        if (finalAvailability[day].selected) {
          const timeSlots = generateTimeSlots(finalAvailability[day].startTime, finalAvailability[day].endTime)
          finalAvailability[day].timeSlots = timeSlots;
        }
      });
      setAvailability(finalAvailability);
    };

    const navigate = useNavigate();

    const handleAddProctor = async () => {
      if (!isValid) {
        alert("You must select start and end times for all selected days");
        return;
      }

      if (isValid) {
        navigate("/addproctorsuccess");
        updateTimeSlots();
      }

      await addProctorAvailability(proctorFirstName, proctorLastName, availability, proctorLocation);
    }

    const handleBack = () => {
      navigate(-1); // Go back to the previous page in the history stack
    };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <Container className="centered-form rounded">
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleAddProctor();
        }}>
          <h2 className="text-center my-4">Proctor Availability</h2>
          
          <Form.Group className="mb-3">
            <Form.Label>Proctor first name</Form.Label>
            <Form.Control
              required
              type="text" 
              onChange={handleProctorFirstName}
              placeholder='Enter proctor first name' 
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Proctor last name</Form.Label>
            <Form.Control
              required
              type="text" 
              onChange={handleProctorLastName}
              placeholder='Enter proctor last name' 
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Select the availability days</Form.Label>
            {Object.keys(availability).map((day) => (
              <Stack key={day} gap={4}>
                <div>
                  <Form.Check  
                    type="checkbox"
                    label={day}
                    checked={availability[day].selected}
                    onChange={() => handleDayChange(day)}
                  />
                   {availability[day].selected && (
                    <div>
                      <Form.Group as={Row} className="mb-3 g-0">
                        <Col>
                          <Form.Control 
                            as="select" 
                            className="custom-time-select"
                            onChange={(e) => handleStartTime(day, e)}
                          >
                            <option value="">--:--</option>
                            {timeOptions.map((time, index) => (
                              <option key={index} value={time}>
                                {time}
                              </option>
                            ))}
                          </Form.Control>
                        </Col>
                        <Col className="d-flex align-items-center justify-content-center custom-time-select">
                          <span>–</span>
                        </Col>
                        <Col>
                          <Form.Control   
                            as="select" 
                            className="custom-time-select"
                            onChange={(e) => handleEndTime(day, e)}
                          >
                            <option value="">--:--</option>
                            {dynamicEndTimes(day).map((time, index) => (
                              <option key={index} value={time}>
                                {time}
                              </option>
                            ))}
                          </Form.Control>
                        </Col>
                      </Form.Group>
                    </div>
                  )}
                </div>
              </Stack>
            ))}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Available Location</Form.Label>
            <Form.Control
              required
              type="text" 
              onChange={handleLocation}
              placeholder='Enter room number for proctoring' 
            />
          </Form.Group>

          <div className="d-flex justify-content-between">
            <Button variant="success" type="submit" className="mt-2">
              Submit
            </Button>
            <Button 
              variant="success"
              onClick={handleBack} 
              className="mt-2"
              type="button"
            >
              Back
            </Button>
          </div>

        </Form>
      </Container>
    </div>
  );
}

export default AddProctor
